import React from "react";
import $ from "jquery";
import * as omnimap from "../../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";
import * as GC from "../../../../../common/common";

class CreateManagementUnit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      naam: "",
      naamRequiredAlert: "",
      email: "",
      website: "",
      straat: "",
      nummer: "",
      postcode: "",
      woonplaats: "",
      opmerking: "",
      isUitvoerder: "",
      active: true,
    };
    this.baseState = this.state;
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  resetForm = async () => {
    await this.setState(this.baseState);
    await this.setState({ code: GC.CodeAutoFill("BE") });
  };

  addParentFolder(childId) {
    var that = this;
    var parentId = $("#tree-parent-id").val();
    var model = { folder: parentId };

    omnimap
      .AddParentFolderAction(
        model,
        childId,
        window.$catalog_management_units_token
      )
      .then((result) => {
        console.log(result);
      });
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });

    if (value != "" && name == "begin") {
      this.setState({ beginRequiredAlert: false });
    }
    if (value != "" && name == "end") {
      this.setState({ endRequiredAlert: false });
    }
    if (value != "" && name == "naam") {
      this.setState({ naamRequiredAlert: false });
    }
  }

  async handleSubmit(event) {
    event.preventDefault();
    $("#cover-spin").show(0);

    this.state.naam == ""
      ? await this.setState({ naamRequiredAlert: true })
      : await this.setState({ naamRequiredAlert: false });

    var model = {
      relationships: { definition: { code: "ORGANISATION" } },
      content: {
        algemeen: {
          actief: this.state.active,
          isuitvoerder: this.state.isUitvoerder,
          naamorganisatie: this.state.naam,
          email: this.state.email,
          website: this.state.website,
          straat: this.state.straat,
          nummer: this.state.nummer,
          postcode: this.state.postcode,
          woonplaats: this.state.woonplaats,
          opmerking: this.state.opmerking,
        },
      },
    };

    let isUnique = true;
    let uniqueModel = {
      content: [
        {
          and_or: "AND",
          datatype: "STRING",
          key: "algemeen-naamorganisatie",
          values: [this.state.code],
        },
      ],
      definitions: [process.env.REACT_APP_USER_ORGANISATION],
      sorting: [],
    };

    //** code isunique control.
    await omnimap
      .FillTableAction(uniqueModel, 1, window.$catalog_management_units_token)
      .then((result) => {
        if (result.data && result.data.length > 0) {
          isUnique = false;
          this.setState({
            codeRequiredAlert: true,
            codeAlertText: "is not unique",
          });
        }
      });

    if (this.state.naamRequiredAlert !== true && isUnique === true) {
      var data = await omnimap.SaveOrEditAction(
        model,
        "POST",
        "",
        window.$catalog_management_units_token
      );
      if (data.result.status === "OK") {
        $("#cover-spin").hide(0);
        $("#cat-organisatie-add-modal").modal("hide");
      } else {
        alert(data.result.status);
        $("#cover-spin").hide(0);
      }
    } else {
      $("#cover-spin").hide(0);
    }
  }

  async componentDidMount() {
    var that = this;
    $(document).on("click", "#cat-organisatie-add", function () {
      $("#cat-organisatie-add-modal").modal("show");
      that.resetForm();
    });
  }

  render() {
    return (
      <div
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        id="cat-organisatie-add-modal"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Nieuwe Organisatie</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <label
                className={
                  this.state.naamRequiredAlert
                    ? "modale-submit-alert-block"
                    : ""
                }
              >
                Naam organisatie *
              </label>
              <label
                className={
                  this.state.naamRequiredAlert
                    ? "modale-submit-alert-block"
                    : "modale-submit-alert-none"
                }
              >
                {"\u00A0"} required
              </label>
              <input
                type="input"
                className="form-control"
                name="naam"
                value={this.state.naam}
                onChange={this.handleInputChange}
                autocomplete="off"
              />
              <label>e-mail</label>
              <input
                type="input"
                className="form-control"
                name="email"
                value={this.state.email}
                onChange={this.handleInputChange}
                autocomplete="off"
              />

              <label>Website</label>
              <input
                type="input"
                className="form-control"
                name="website"
                value={this.state.website}
                onChange={this.handleInputChange}
                autocomplete="off"
              />
              <label>Straat</label>
              <input
                type="input"
                className="form-control"
                name="straat"
                value={this.state.straat}
                onChange={this.handleInputChange}
                autocomplete="off"
              />
              <label>Nummer</label>
              <input
                type="input"
                className="form-control"
                name="nummer"
                value={this.state.nummer}
                onChange={this.handleInputChange}
                autocomplete="off"
              />
              <label>Postcode</label>
              <input
                type="input"
                className="form-control"
                name="postcode"
                value={this.state.postcode}
                onChange={this.handleInputChange}
                autocomplete="off"
              />
              <label>Woonplaats</label>
              <input
                type="input"
                className="form-control"
                name="woonplaats"
                value={this.state.woonplaats}
                onChange={this.handleInputChange}
                autocomplete="off"
              />
              <label>Opmerking</label>
              <input
                type="input"
                className="form-control"
                name="opmerking"
                value={this.state.opmerking}
                onChange={this.handleInputChange}
                autocomplete="off"
              />

              <label>Actief</label>
              <label className="switch">
                <input
                  id="beheereenheid_active"
                  type="checkbox"
                  defaultChecked
                  name="active"
                  value={this.state.active}
                  onChange={this.handleInputChange}
                />
                <span className="slider-checkbox round" />
              </label>
              <label>Is uitvoerder</label>
              <label className="switch">
                <input
                  id="beheereenheid_active"
                  type="checkbox"
                  defaultChecked
                  name="isUitvoerder"
                  value={this.state.isUitvoerder}
                  onChange={this.handleInputChange}
                />
                <span className="slider-checkbox round" />
              </label>
              <br />
              <br />
            </div>
            <div className="modal-footer">
              <button
                type="button"
                id="save_beheereenheid"
                className="btn-modal"
                onClick={this.handleSubmit.bind(this)}
              >
                Verwerken
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CreateManagementUnit;
